import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import EditOrderInfo from "../../../BookModule.module.css";
import DatePicker_book from "../../../DatePicker_book";
import moment from "moment";
import { AxiosInstance } from "../../../../../../../axios";
import toast from "react-hot-toast";
export default function EditPreOrder() {
  const navigate = useNavigate();
  const { book_id, id } = useParams();
  const navigateToPreviousScreen = () => {
    // navigate("/studyMaterials/Books/list/3");
    navigate(-1);
  };

  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;

  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
    }
  } else {
    console.log("UserId Not available");
  }

  useEffect(() => {
    FindIDView(book_id, id);
  }, []);

  const book_name_ref = useRef(null);
  const purchase_count_ref = useRef(null);
  const pre_order_count_ref = useRef(null);
  const book_expected_date_ref = useRef(null);

  const [listErrors, setListErrors] = useState({});
  const [dateOrderItem, setDateOrderItem] = useState({
    book_name: "",
    purchase_count: "",
    pre_order_count: "",
    book_expected_date: "",
  });
  const preOrderChange = (e) => {
    const { name, value } = e.target;
    setDateOrderItem((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setListErrors((prevState) => ({
      ...prevState,
      [name]: "",
    }));
    if (name === "pre_order_count") {
      const regex = /^[1-9][0-9]{0,4}$/;
      if (regex.test(value)) {
        setDateOrderItem((prev) => ({
          ...prev,
          [name]: value,
        }));

        setListErrors((prev) => ({
          ...prev,
          [name]: "",
        }));
      } else {
        let errorMsg = "";

        if (value < 0) {
          errorMsg = "Value cannot be negative";
        } else if (value.length > 5) {
          errorMsg = "Value cannot exceed 5 digits";
        } else {
          errorMsg = "Please enter a valid number between 1 and 99999";
        }

        setListErrors((prev) => ({
          ...prev,
          [name]: errorMsg,
        }));
      }
    }
  };

  const handlePreOrderChangeDate = (date, name) => {
    const dateEYD = moment(date).format("DD/MM/YYYY");
    setDateOrderItem((prevState) => ({
      ...prevState,
      [name]: dateEYD,
    }));
    setListErrors((prevState) => ({
      ...prevState,
      [name]: "",
    }));
  };

  const FindIDView = (bookid, IDB) => {
    let statusFilter = {
      id: IDB,
      category_id: "",
      group_course_id: "",
      subject_id: "",
      medium: "",
    };
    AxiosInstance.post("api/book/preorder_view", statusFilter)
      .then((res) => {
        if (res.data.status) {
          const HDF = {
            book_name: res.data.data?.book_title,
            purchase_count: res.data.data?.purchase_count,
            pre_order_count: res.data.data?.order_count,
            book_expected_date: moment(
              res.data.data?.expected_date,
              "YYYY-MM-DD"
            ).format("DD/MM/YYYY"),
          };
          setDateOrderItem(HDF);
        } else {
          setDateOrderItem({});
        }
      })
      .catch((error) => {
        return error;
      });
  };

  const validateEditPreOrder = (datas) => {
    const errors = {};
    if (!datas.book_name) {
      errors.book_name = "Book Name is required";
    }
    // if (!datas.purchase_count) {
    //   errors.purchase_count = "Purchase count is required";
    // }
    if (!datas.pre_order_count) {
      errors.pre_order_count = "Preorder count is required";
    } else {
      const value = datas.pre_order_count;
      const regex = /^[1-9][0-9]{0,4}$/;

      if (!regex.test(value)) {
        if (value < 0) {
          errors.pre_order_count = "Value cannot be negative";
        } else if (value.toString().length > 5) {
          errors.pre_order_count = "Value cannot exceed 5 digits";
        } else {
          errors.pre_order_count =
            "Please enter a valid number between 1 and 99999";
        }
      }
    }
    if (!datas.book_expected_date) {
      errors.book_expected_date = "Book expected date is required";
    }
    validateEditPreOrderFocus(datas);
    return errors;
  };

  const validateEditPreOrderFocus = (objs) => {
    if (!objs.book_name) {
      book_name_ref.current.focus();
    }
    if (!objs.purchase_count) {
      purchase_count_ref.current.focus();
    }
    if (!objs.pre_order_count) {
      pre_order_count_ref.current.focus();
    }
    if (!objs.book_expected_date) {
      book_expected_date_ref.current.setFocus();
    }
  };
  const handleSubmit = () => {
    const errorss = validateEditPreOrder(dateOrderItem);
    if (Object.keys(errorss).length === 0) {
      const dataI = {
        id: parseInt(id),
        book_id: dateOrderItem.book_name,
        order_count: dateOrderItem.pre_order_count,
        purchase_count: dateOrderItem.purchase_count,
        expected_date: moment(
          dateOrderItem.book_expected_date,
          "DD/MM/YYYY"
        ).format("YYYY-MM-DD"),
        created_dt: moment().format("YYYY-MM-DD"),
        created_by: userid,
      };
      AxiosInstance.post("/api/book/create_preorder", dataI)
        .then((res) => {
          if (res.data.status) {
            toast.success(res.data.message);
            navigateToPreviousScreen();
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((error) => {
          return error;
        });
    } else {
      setListErrors(errorss);
    }
  };

  return (
    <div className="BathHeader global_container">
      <div className="row mx-0">
        <div className="col-md-6 col-12 px-0">
          <h2 className="TitleHeader">Edit Pre-Orders</h2>
        </div>
        <div className="col-md-6 col-12 ListBtn px-0">
          <ul class="List-Button">
            <li class="ListBtnItems">
              <Link
                to={"javascript:void(0)"}
                onClick={navigateToPreviousScreen}
                className="secondaryButton "
                variant="secondary"
              >
                {id ? "Back to View Pre-Order" : "Back to Books"}
              </Link>
            </li>
            <li className="ListBtnItems">
              <Link
                to={"javascript:void(0)"}
                onClick={handleSubmit}
                className="primaryButton"
              >
                Save Pre-Orders
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="row mt-3 mb-2">
        <div className="col-xl-12 col-lg-12 col-md-12 col-12">
          <fieldset className={EditOrderInfo.preorderContainer}>
            <legend className="w-auto mb-0">Pre-Order Book</legend>
            <div className="row mx-0">
              <div class="col-xl-6 col-lg-6 mb-3 ps-0 col-md-6 col-12 ps-0 d-flex flex-column">
                <label
                  for="CourseName"
                  class="form-label confirm_value disabled_btn"
                >
                  Book Name
                </label>
                <input
                  ref={book_name_ref}
                  className={`${EditOrderInfo.textInputBox} disabled_btn`}
                  type="text"
                  disabled
                  id="book_name"
                  name="book_name"
                  placeholder="Book Name"
                  onChange={(e) => preOrderChange(e)}
                  value={dateOrderItem.book_name}
                />
                {listErrors.book_name && (
                  <small className={`error_message mt-2`}>
                    {listErrors.book_name}
                  </small>
                )}
              </div>

              <div class="col-xl-6 col-lg-6  ps-0 col-md-6 py-0 col-12 d-flex flex-column">
                <label
                  for="purchase_count"
                  class="form-label confirm_value disabled_btn"
                >
                  Purchase Count
                </label>
                <input
                  ref={purchase_count_ref}
                  className={`${EditOrderInfo.textInputBox} disabled_btn`}
                  type="number"
                  disabled
                  id="purchase_count"
                  name="purchase_count"
                  placeholder="Purchase Count"
                  onChange={(e) => preOrderChange(e)}
                  value={dateOrderItem.purchase_count}
                />
                {/* {listErrors.purchase_count && (
                  <small className={`error_message mt-2`}>
                    {listErrors.purchase_count}
                  </small>
                )} */}
              </div>
              <div class="col-xl-6  col-lg-6 mb-3 ps-0 col-md-6 ps-0 col-12 d-flex flex-column">
                <label for="pre_order_count" class="form-label confirm_value ">
                  Pre-Order Count
                </label>
                <input
                  ref={pre_order_count_ref}
                  className={`${EditOrderInfo.textInputBox}`}
                  type="number"
                  id="pre_order_count"
                  name="pre_order_count"
                  placeholder="Enter pre order count"
                  onChange={(e) => preOrderChange(e)}
                  value={dateOrderItem.pre_order_count}
                />
                {listErrors.pre_order_count && (
                  <small className={`error_message mt-2`}>
                    {listErrors.pre_order_count}
                  </small>
                )}
              </div>
              <div class="col-xl-6 col-lg-6  ps-0 col-md-6 py-0 col-12 d-flex flex-column">
                <label
                  for="book_expected_date"
                  class="form-label confirm_value "
                >
                  Expected by Date
                </label>

                <DatePicker_book
                  txtAdMDob={book_expected_date_ref}
                  class={`${EditOrderInfo.textInputBox}`}
                  name={"book_expected_date"}
                  errors_date={listErrors.book_expected_date}
                  IconInput={EditOrderInfo.DateIconInput}
                  handleChange={handlePreOrderChangeDate}
                  fieldInput={dateOrderItem.book_expected_date}
                  minDate={moment().add(1, "days").toDate()} // Start from tomorrow
                />
              </div>
            </div>
          </fieldset>
        </div>
      </div>
      <div className="row mt-3 mb-4 mx-0">
        <div className="col-md-12 col-12 ListBtn px-0">
          <ul class="List-Button">
            <li class="ListBtnItems">
              <Link
                to={"javascript:void(0)"}
                onClick={navigateToPreviousScreen}
                className="secondaryButton "
                variant="secondary"
              >
                {id ? "Back to View Pre-Order" : "Back to Books"}
              </Link>
            </li>
            <li className="ListBtnItems">
              <Link
                to={"javascript:void(0)"}
                onClick={handleSubmit}
                className="primaryButton"
              >
                Save Pre-Orders
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
